import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router'
import { z } from 'zod'

const searchSchema = z.object({
  tab: z.enum(['plan', 'craft', 'dashboard', 'test-cases']).optional(),
  node: z.string().optional(),
})

export const Route = createFileRoute('/_protected/studio/$workflowId')({
  validateSearch: searchSchema,
  component: lazyRouteComponent(
    () => import('@/pages/studio-mock/workflow-detail/page'),
    'WorkflowDetailPage',
  ),
})
